<div id="pricing" class="mt-2 pt-3">
    <div fxLayout="column" fxLayoutAlign="center center" class="title-section p-2 mb-2">  
        <h1>Plans and Pricing</h1>             
        <p class="secondary-text-color">Choose the plan that's best for your business.</p>
    </div>
    <mat-tab-group class="pricing-tabs">
        <mat-tab label="MONTHLY"><app-monthly></app-monthly></mat-tab>
        <mat-tab label="YEARLY"><app-yearly></app-yearly></mat-tab>
    </mat-tab-group>
</div> 